<script>
    import ForgotPassword from "./ForgotPassword";

    export default {
        name: "AccountConflict",
        mixins: [ForgotPassword],
        computed: {
            token() {
                return this.$route.params.token ?? '';
            },
            email() {
                let email = this.$route.params.email ?? '';

                if (email === '-') {
                    return '';
                }

                return email;
            },
            title() {
                return 'Confirm your email';
            },
            description() {
                return 'You must confirm your email and set a new password to use all Navitas platforms. ' +
                    'Login with username will no longer be possible. ' +
                    'You will not be able to access your account until you have verified your email address.';
            }
        },
        methods: {
            actionSubmit() {
                this.loadingState = true;
                let email = this.$refs.email.value ?? '';

                this.$api.sendConfirmEmail({
                    data: {
                        token: this.token,
                        email: email,
                    }
                }).then(() => {
                    this.$router.push(this.$enums.RoutePathEnum.LOGIN);
                }).finally(() => {
                    this.loadingState = false;
                });
            }
        },
    }
</script>